import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import LoginPage from "@/pages/LoginPage";
import ChartsGalleryPage from "@/pages/ChartsGalleryPage";
import ChartPage from "@/pages/ChartPage";
import DirectoryPage from "@/pages/DirectoryPage";
import ImportPage from "@/pages/ImportPage";
import SettingsPage from "@/pages/SettingsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ProfilePage from "@/pages/ProfilePage";
import ShareViewPage from "@/pages/ShareViewPage";
import OperatorPage from "@/pages/OperatorPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <div className="w-10 h-10 rounded-full border-4 border-[#6161FF] border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Shell>{children}</Shell>;
}

function NonViewer({ children }) {
  const { user } = useAuth();
  if (user?.role === "viewer") return <Navigate to="/" replace />;
  return children;
}

function OperatorOnly({ children }) {
  const { user } = useAuth();
  if (!user?.platform_operator) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/share/:token" element={<ShareViewPage />} />
          <Route path="/" element={<Protected><ChartsGalleryPage /></Protected>} />
          <Route path="/chart/:viewId" element={<Protected><ChartPage /></Protected>} />
          <Route path="/directory" element={<Protected><DirectoryPage /></Protected>} />
          <Route path="/analytics" element={<Protected><NonViewer><AnalyticsPage /></NonViewer></Protected>} />
          <Route path="/imports" element={<Protected><NonViewer><ImportPage /></NonViewer></Protected>} />
          <Route path="/settings" element={<Protected><NonViewer><SettingsPage /></NonViewer></Protected>} />
          <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
          <Route path="/operator" element={<Protected><OperatorOnly><OperatorPage /></OperatorOnly></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
